/**
 * Pure rules: when enrollment/batch fields are required on Add/Edit student.
 */

import { STUDENT_ID_INTAKE_MODES } from '../identity/studentIdIntake';

export function isLeadIntakeMode(mode) {
  return String(mode || '').trim() === STUDENT_ID_INTAKE_MODES.LEAD;
}

/**
 * Lead create path, or edit of a student with no enrollment, does not require a batch.
 * @param {{ intakeMode?: string, isLeadLike?: boolean }} opts
 */
export function enrollmentBatchRequired({ intakeMode, isLeadLike = false } = {}) {
  return !(isLeadIntakeMode(intakeMode) || isLeadLike);
}

const ENROLL_KEYS = ['courseId', 'modeOfCourse', 'batchStartDate', 'batchId', 'locationOfCenter'];

export function hasAnyEnrollmentField(formData = {}) {
  return ENROLL_KEYS.some((key) => String(formData[key] || '').trim() !== '');
}

/**
 * Enough fields to call /batches/ensure (and optionally enroll).
 */
export function canCreateEnrollmentBatch(formData = {}) {
  const courseId = String(formData.courseId || '').trim();
  const mode = String(formData.modeOfCourse || '').trim();
  const startDate = String(formData.batchStartDate || '').trim();
  if (!courseId || !mode || !startDate) return false;
  if (mode === 'Offline' && !String(formData.locationOfCenter || '').trim()) return false;
  return true;
}

function missingComboFields(formData = {}) {
  const missing = [];
  if (!String(formData.courseId || '').trim()) missing.push('Course');
  if (!String(formData.modeOfCourse || '').trim()) missing.push('Mode');
  if (!String(formData.batchStartDate || '').trim()) missing.push('Batch start date');
  if (
    String(formData.modeOfCourse || '').trim() === 'Offline' &&
    !String(formData.locationOfCenter || '').trim()
  ) {
    missing.push('Center');
  }
  return missing;
}

/**
 * If the operator started filling enrollment, require a complete combo
 * (unless lead and they left everything blank).
 */
export function missingEnrollmentFieldsForSave(
  formData = {},
  { intakeMode, isLeadLike = false } = {}
) {
  const required = enrollmentBatchRequired({ intakeMode, isLeadLike });
  if (!required) {
    if (!hasAnyEnrollmentField(formData)) return [];
    if (String(formData.batchId || '').trim()) return [];
    if (canCreateEnrollmentBatch(formData)) return [];
    return missingComboFields(formData);
  }
  if (String(formData.batchId || '').trim()) return [];
  if (canCreateEnrollmentBatch(formData)) return [];
  return missingComboFields(formData);
}
